var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mid-autumn-body",attrs:{"id":"midAutumn"}},[_c('div',{staticClass:"latern",attrs:{"id":"latern"}},_vm._l((_vm.list),function(item,index){return _c('div',{class:_vm.getRandomLaternClass(),style:({
                left: item.left,
                bottom: item.bottom,
                animationDelay: item.animationDelay
            })},[_c('div',{staticClass:"latern-left"}),_c('div',{staticClass:"latern-right"}),_c('div',{staticClass:"latern-bottom"})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }